import React from "react"
import { BlockContextConsumer } from "./ContextProviders"

export default function withContext(Element) {
    return function withContext(props) {
        return (
            <BlockContextConsumer>
                {context => <Element {...props} context={context} />}
            </BlockContextConsumer>
        )
    }
}



// WEBPACK FOOTER //
// ./src/features/editor/withContext.js